/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Position } from './Position';

export type FeatureType = {
    id: string;
    displayName: string;
    ghModelReference: string;
    snapClass: FeatureType.snapClass;
    defaultPosition: Position;
    featureFolderIds: Array<string>;
}

export namespace FeatureType {

    export enum snapClass {
        WINDOW = 'WINDOW',
        DOOR = 'DOOR',
    }


}
